import { useEffect, useRef } from 'react';
import { toaster } from 'toasterhea';
export const Popup = toaster();
export function useBoundingClientRectEffect({ anchorRef, translateFn, onUpdate, deps = [], }) {
    const onUpdateRef = useRef(onUpdate);
    if (onUpdateRef.current !== onUpdate) {
        onUpdateRef.current = onUpdate;
    }
    useEffect(() => {
        if (!anchorRef) {
            return () => { };
        }
        function update() {
            onUpdateRef.current?.((translateFn || None)(anchorRef?.current?.getBoundingClientRect()));
        }
        update();
        window.addEventListener('resize', update);
        window.addEventListener('scroll', update);
        return () => {
            window.removeEventListener('resize', update);
            window.removeEventListener('scroll', update);
        };
    }, [anchorRef, translateFn, ...deps]);
}
export const None = () => {
    return { x: 0, y: 0 };
};
export const South = (rect) => {
    const { x = 0, y = 0, width = 0, height = 0 } = rect || {};
    return { x: x + width / 2, y: y + height };
};
export const North = (rect) => {
    const { x = 0, y = 0, width = 0 } = rect || {};
    return { x: x + width / 2, y };
};
export const SouthEast = (rect) => {
    const { x = 0, y = 0, width = 0, height = 0 } = rect || {};
    return { x: x + width, y: y + height };
};
export const SouthWest = (rect) => {
    const { x = 0, y = 0, height = 0 } = rect || {};
    return { x: x, y: y + height };
};
export const NorthWest = (rect) => {
    const { x = 0, y = 0 } = rect || {};
    return { x: x, y: y };
};
export const East = (rect) => {
    const { x = 0, y = 0, width = 0, height = 0 } = rect || {};
    return { x: x + width, y: y + height / 2 };
};
export const Middle = (rect) => {
    const { x = 0, y = 0, width = 0, height = 0 } = rect || {};
    return { x: x + width / 2, y: y + height / 2 };
};
